export default __webpack_public_path__ + "static/media/263.1873ca7f.jpg";